import React, { useState } from 'react';
import moment from 'moment';

// mui
import { Grid, Container, Typography, Box } from '@mui/material';

// collections
import JobsInDateRange from './collections/JobsInDateRange/JobsInDateRange.collection';

// blockgroups
import SearchField from '../../../blockGroups/search/SearchField/SearchField.blockgroup';

const searchFieldOptions = [
    { value: 'name', title: 'Name'},
    { value: 'id', title: 'Number'},
]

export default function MyJobs() {

    const [searchBy, setSearchBy] = useState(null)
    const [searchValue, setSearchValue] = useState(null)

    // times
    const today = moment()

    const upcomingStart = today.clone().add(1, 'day').format("YYYY-MM-DD")
    const upcomingEnd = today.clone().add(6, 'months').format("YYYY-MM-DD")

    const thisWeekStart = today.clone().startOf('week').add(1, 'day').format("YYYY-MM-DD")
    const thisWeekEnd = today.clone().endOf('week').add(1, 'day').format("YYYY-MM-DD")

    const pastStart = today.clone().subtract(6, 'months').format("YYYY-MM-DD")
    const pastEnd = today.clone().subtract(1, 'day').format("YYYY-MM-DD")

    const handleSearchClicked = (searchValue, searchBy) => {
        setSearchValue(searchValue)
        setSearchBy(searchBy)
    }

    return (<div>

        <Container disableGutters sx={{ marginBottom: 4 }}>
        <Grid container justifyContent="center">
            <Grid item>
            <Typography variant="h2">
                My Jobs
            </Typography>
            </Grid>
        </Grid>
        </Container>

        <Box sx={{ marginBottom: 4 }}>
            <SearchField fieldOptions={searchFieldOptions} onSearchClicked={handleSearchClicked} />
        </Box>
        
        <JobsInDateRange label='This Week'
            filterOptions={{ searchBy, searchValue }}
            startDate={thisWeekStart}
            endDate={thisWeekEnd}
        />
        <JobsInDateRange label='Starting Next 6 Months' 
            filterOptions={{ searchBy, searchValue }}
            startDate={upcomingStart}
            endDate={upcomingEnd}
        />
        <JobsInDateRange label='Already Started' 
            filterOptions={{ searchBy, searchValue }}
            startDate={pastStart}
            endDate={pastEnd}
        />

        </div>)
}